// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1lzFE","actionArea":"styles_actionArea__3vblF","image":"styles_image__3HOWS","content":"styles_content__2GR6A","name":"styles_name__2FjsQ"};